<template>
  <div id="login-container">

    <div id="login-form">

      <h3 class="header">
        {{logoTitle}}
        <span>v1.4.5</span>
      </h3>

	  <img class="logo-img" :src="logo" alt="">

      <!-- 输入用户名 -->
      <div class="input-item">
        <el-input
          v-model="userInfo.username"
          clearable
          placeholder="用户名"
		  maxlength="20"
		  onkeyup="this.value=this.value.replace(/[^\w\u4e00-\u9fa5]/g,'')"
          prefix-icon="el-icon-user">
        </el-input>

        <!-- 登录信息提示 -->
        <p class="error-p">{{error_name}}</p>
      </div>


      <!-- 输入密码 -->
      <div class="input-item">
        <el-input
          v-model="userInfo.password"
          clearable
          placeholder="密码"
          prefix-icon="el-icon-lock"
          show-password
		  maxlength="20"
		  onkeyup="this.value=this.value.replace(/[\s+]/g,'')"
          @keyup.enter.native="loginHandle">
        </el-input>

        <!-- 登录信息提示 -->
        <p class="error-p">{{error_password}}</p>
      </div>

      <!-- 验证码部分 -->
      <div class="input-item">
        <!-- <span class="code-span">验证码：</span> -->
        <el-input
          type="text"
          v-model="userInfo.code"
          name="code"
          placeholder="请输入验证码"
		  onkeyup="this.value=this.value.replace(/[^0-9a-zA-Z]/g,'')"
          @keyup.enter.native="loginHandle">
          <template slot="prepend">
            <img class="code-img" :src="code_src" alt="看不清楚?换一张" @click="updateCode">
          </template>
          </el-input>
          <!-- 登录信息提示 -->
          <p class="error-p">{{error_code}}</p>
      </div>

      <button class="btn" ref="logbtn" :disabled="logbtn_use"  @click="loginHandle">登录</button>
    </div>
  </div>
</template>

<script>
import {getCode} from '@/api/login'
import jwtDecode from 'jwt-decode'
import {newRouter} from '@/router'

export default {
  name: 'Login',
  data() {
    return {
      userInfo: {
        username: this.$store.getters['user/userName'],
        password: '',
        code: ''
      },
      code_src: '',
      error_name: '',
      error_password: '',
      error_code: '',
      error_input: false,
	  logbtn_use : false,
	  logoTitle:localStorage.getItem('logoTitle')  == null
		? '萝卜牛自动驾驶指挥平台': localStorage.getItem('logoTitle')  == 'null' 
			?  '萝卜牛自动驾驶指挥平台': localStorage.getItem('logoTitle')  == 'undefined' 
				? '萝卜牛自动驾驶指挥平台': localStorage.getItem('logoTitle'),
	  logo:localStorage.getItem('logo')  == null
		? require('../../assets/img/logo.png') :localStorage.getItem('logo')  == 'null' 
			? require('../../assets/img/logo.png') : localStorage.getItem('logo')  == 'undefined' 
				? require('../../assets/img/logo.png') : localStorage.getItem('logo')
    }
  },
  methods: {
    check_inputs() {
      if (this.userInfo.username === '') {
        this.error_name = '用户名不能为空'
        this.error_input = true
      } else {
        this.error_name = ''
      }
      if (this.userInfo.password === '') {
        this.error_password = '密码不能为空'
        this.error_input = true
      } else {
        this.error_password = ''
      }
      if (this.userInfo.code === '') {
        this.error_code = '验证码不能为空'
        this.error_input = true
      } else {
        this.error_code = ''
      }
    },
    updateCode() {
      const randnum = Math.ceil(Math.random() * 100)   // 生成随机数（防止图片缓存）
      getCode(randnum).then(res => {
        // this.code_src = '/api/gen_verifycode?' + randnum
        this.code_src=window.URL.createObjectURL(new Blob([res]))
      })
    },
	setloginbtn(aviabled){
		if(aviabled == false){		
			this.logbtn_use = true
			this.$refs.logbtn.style.backgroundColor='#948f8a'
			this.$refs.logbtn.innerHTML = '登录中' 
		}else{
			this.logbtn_use = false
			this.$refs.logbtn.style.backgroundColor='#00bca4'
			this.$refs.logbtn.innerHTML = '登录'
		}
	},
    loginHandle() {
		
      // 首先前端验证验证输入是否正确
      this.check_inputs()

      if (!this.error_input) {
		  
		  this.setloginbtn(false)
		  
		 this.$store.dispatch('user/login', this.userInfo).then(async res => {
			  
			  // 请求成功，根据返回结果进行提示
			  let loginStatus = res.loginStatus
			  switch (loginStatus) {
				  case -2:
					this.error_name = ''
					this.error_password = ''
					this.error_code = '验证码错误'
					this.setloginbtn(true)
					break
				  case -1:
					this.error_name = '用户名错误'
					this.error_password = ''
					this.error_code = ''
					this.setloginbtn(true)
					break
				  case 0:
					this.error_name = ''
					this.error_password = '密码输入错误'
					this.error_code = ''
					this.setloginbtn(true)
					break
				  case 1:
					// 登录成功，请求菜单 以及 运营单位
					localStorage.setItem('x-user',this.userInfo.username)
					localStorage.setItem('logoTitle',res.logoTitle)
					localStorage.setItem('logoMenu',res.logoMenu)
					localStorage.setItem('logo',res.logo)
					
					this.$root.closeTages = true;
					await this.$store.dispatch('user/getMenu')
					await this.$store.dispatch('user/getEntity')
					// 登录后获取动态路由加载
					newRouter()
					this.setloginbtn(true)
					break;
				  default:
					break;
			}
			// 更新验证码
			this.updateCode()
			// 登录后路由到主页，不需要判断是否登录成功，因为只有登录成功，token才是正确的，才会正确路由
			this.$router.push('/index')
      })
      }
      this.error_input = false;
    }
  },
  created() {
    this.updateCode()
  }
}

</script>


<style scoped>
  #login-container {
    /* height:600px;
    width: 300px;
    margin: 0 auto; */
    text-align:center;
    margin-top: 10px;

    min-height: 100%;
    width: 100%;
    background-color: #2d3a4b;
    overflow: hidden;

  }

  #login-form {
    /* border: 2px solid #555a60;
    margin-top: 10px; */

    position: relative;
    top: 150px;
    width: 400px;
    max-width: 100%;
    padding: 70px 35px 0;
    margin: 0 auto;

    overflow: hidden;

  }

  .header {
    color: #c2c2c2;
    font-size: 23px;

    position: relative;
    padding: 35px;
  }

  #login-form .logo-img {
    height: 100px;
   /* margin: 20px 20px 0; */
   margin-top:-20px;
   margin-bottom: 35px;
  }

  .input-item {
    /* padding: 4px 20px; */

    border: 1px solid rgba(255,255,255,0.1);
    background: rgba(0,0,0,0.1);
    border-radius: 5px;
    color: #454545;

  }

  .error-p {
    font-size: 12px;
    color: red;
    height: 12px;
    border: 1px solid transparent;
    text-align: left;
  }

  .btn {
    color: #fff;
    background-color: #00bca4;
    height: 34px;
    line-height: 12px;
    /* width: 260px; */
    /* margin: 10px 20px; */
    border-radius: 3px;
    border-color: #00a792;
    width: 100%;
    margin-bottom: 30px;
  }
</style>
